document.addEventListener('click', function (event) {
  var button = event.target.closest(
    '.product--thumbnail_slider media-gallery > slider-component:not(.thumbnail-slider) .slider-button'
  );
  if (!button) return;
  event.preventDefault();

  var gallery = button.closest('media-gallery');
  if (!gallery) return;

  var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
  if (!thumbnails) return;

  var items = Array.from(thumbnails.querySelectorAll('.thumbnail-list__item'));
  var currentIndex = items.findIndex(function (item) {
    return item.querySelector('.thumbnail[aria-current="true"]');
  });
  if (currentIndex === -1) return;

  var direction = button.classList.contains('slider-button--next') ? 1 : -1;
  var nextIndex = currentIndex + direction;
  if (nextIndex < 0) nextIndex = items.length - 1;
  if (nextIndex >= items.length) nextIndex = 0;

  var nextButton = items[nextIndex].querySelector('button');
  if (nextButton) nextButton.click();
});
